import { JepGraphic } from '@jeppesen-foreflight/jmkw-types';
import * as stringUtils from '../../../../utilities/string-format.utils';
import { NavigationFeatureType } from '../navigation-feature-type';
import { FeatureDetail } from './feature-detail';
import { AirwayAttributesRaw } from './airway-attributes-raw';
import { AirwayAttributes } from './airway-attributes';

export class Airway implements FeatureDetail {
  id: string;
  navType: NavigationFeatureType = 'airway';
  attributes: AirwayAttributes;

  constructor(public graphic: JepGraphic) {
    this.id = this._getId(graphic?.attributes);
    this.attributes = this._formatAttributes(graphic?.attributes);
  }

  private _getId(attrs?: AirwayAttributesRaw): string {
    return stringUtils.formatString(attrs?.name);
  }

  private _formatAttributes(attrs?: AirwayAttributesRaw): AirwayAttributes {
    if (!attrs) {
      return {
        endCoordinates: '',
        inboundBearing: '',
        minEnrouteAlt: '',
        name: '',
        outboundBearing: '',
        segmentDistance: '',
        segmentEnd: '',
        segmentStart: '',
        segmentType: '',
        startCoordinates: '',
        totalMileage: ''
      };
    }

    return {
      endCoordinates: this._formatCoordinates(attrs.endcoords),
      inboundBearing: this._formatBearing(attrs.inboundbearing),
      minEnrouteAlt: stringUtils.formatAltitude(attrs.mea),
      name: stringUtils.formatString(attrs.name),
      outboundBearing: this._formatBearing(attrs.outboundbearing),
      segmentDistance: this._formatNauticalMiles(attrs.segmentdistance),
      segmentEnd: stringUtils.formatString(attrs.segmentend),
      segmentStart: stringUtils.formatString(attrs.segmentstart),
      segmentType: stringUtils.formatString(attrs.segmenttype),
      startCoordinates: this._formatCoordinates(attrs.startcoords),
      totalMileage: this._formatNauticalMiles(attrs.total_mileage)
    };
  }

  private _formatCoordinates(coords?: string): string {
    if (!coords) return '';
    return stringUtils.formatString(coords);
  }

  private _formatBearing(bearing?: string): string {
    if (!bearing) return '';
    return stringUtils.formatBearing(parseFloat(bearing));
  }

  private _formatNauticalMiles(value?: number): string {
    return stringUtils.formatMeasurement(value, 'nm');
  }
}
